import { BackendApi, Data } from "@/types";
import { ApiResponseOkCodec } from "@/types-io";
import { Either } from "fp-ts/lib/Either";
import { ApiError, get, mkUrl } from "./backend-api-tools";

const api : BackendApi = {
  getData(endpoint: string, args: any): Promise<Either<ApiError, Data>> {
    return get(mkUrl(endpoint, 'data', args), ApiResponseOkCodec, e => e.result)
  }
}

export default api;